import {
  SciBooksIndexSchema,
  SciChapterShardSchema,
  SciManifestSchema,
  type SciBooksIndex,
  type SciChapterShard,
  type SciManifest,
} from './schema';

const SCI_ROOT = '/data/sci';

export class SciDataError extends Error {
  constructor(
    message: string,
    readonly status: number | null,
  ) {
    super(message);
    this.name = 'SciDataError';
  }
}

async function loadJson(url: string): Promise<unknown> {
  let response: Response;
  try {
    response = await fetch(url);
  } catch {
    throw new SciDataError('SCI data request could not reach the server.', null);
  }
  if (!response.ok) {
    throw new SciDataError(
      `SCI data request failed with status ${String(response.status)}.`,
      response.status,
    );
  }
  return response.json();
}

export async function loadSciManifest(): Promise<SciManifest> {
  return SciManifestSchema.parse(await loadJson(`${SCI_ROOT}/manifest.json`));
}

export async function loadSciBooks(): Promise<SciBooksIndex> {
  return SciBooksIndexSchema.parse(await loadJson(`${SCI_ROOT}/books.json`));
}

export async function loadSciChapter(
  bookId: string,
  chapter: number,
): Promise<SciChapterShard> {
  const safeBookId = encodeURIComponent(bookId);
  return SciChapterShardSchema.parse(
    await loadJson(`${SCI_ROOT}/chapters/${safeBookId}/${String(chapter)}.json`),
  );
}
